export {default as LampList} from './List';
export {default as LampExam} from './Exam';
